import type {TaskDefinitionResponse} from 'src/api/ProactApiClient';
import {FormViewRow} from 'src/app/forms/FormViewRow/FormViewRow';

export interface TaskDetailsProps {
  item?: TaskDefinitionResponse;
}
const TaskDetails: React.FC<TaskDetailsProps> = ({item}) => {
  return item !== undefined ? (
    <>
      <FormViewRow label="Creator" value={item!.creator?.name} />
      <FormViewRow
        label="Created Date"
        value={item?.createdAt?.toString().toLongDate()}
      />
      <FormViewRow
        label="Due Date"
        value={item?.dueAt?.toString().toLongDate()}
      />
    </>
  ) : (
    <>No data.</>
  );
};

export default TaskDetails;
